import { __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import { Navigation } from 'swiper';
import { styled, Grid } from '@mui/material';
import { GenericContainer } from '../components/GenericContainer.js';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, WIDGET_MEDIA_BORDER_RADIUS } from '../../utils/constants/Constants.js';
import { checkAndAppendRoutePrefixToLink } from '../../utils/widgetUtils.js';

var _a, _b, _c, _d, _e;
var TextCarouselContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: '5%',
            paddingRight: '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main,
            background: '#fff'
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            background: '#fff',
            padding: "".concat(WIDGET_SPACE_HALF, "px 0px ").concat(WIDGET_SPACE_HALF, "px 0px"),
        },
        _b);
});
var Wrapper = styled('div')((_a = {
        width: '100%',
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        position: 'relative',
        boxSizing: 'border-box'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
    // maxWidth: 550,
    },
    _a['.swiper'] = (_b = {
            position: 'static'
        },
        // maxWidth: 330,
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        //   maxWidth: 270,
        },
        _b),
    _a['.swiper-slide'] = {
        width: '70%',
        margin: 0,
    },
    _a['.swiper-button-prev'] = (_c = {
            background: "url(https://media.brandclub.com/brandclub/image_asset/arrow_left_white.svg)",
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: 40,
            height: 40,
            left: -21
        },
        _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            display: 'none',
        },
        _c['::after'] = {
            content: '""',
        },
        _c),
    _a['.swiper-button-next'] = (_d = {
            background: "url(https://media.brandclub.com/brandclub/image_asset/arrow_right_white.svg)",
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: 40,
            height: 40,
            right: -21
        },
        _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            display: 'none',
        },
        _d['::after'] = {
            content: '""',
        },
        _d),
    _a['.swiper-button-disabled'] = {
        display: 'none',
    },
    _a));
var ImageContainer = styled(Grid)((_e = {
        cursor: 'pointer',
        margin: 'auto',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
        img: { boxSizing: 'border-box', borderRadius: WIDGET_MEDIA_BORDER_RADIUS, width: '100%' },
        transition: 'all 300ms ease-in'
    },
    _e["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {},
    _e['.name'] = {
        marginTop: 10,
        transition: 'opacity 300ms ease-in',
        opacity: 0,
    },
    _e['.city'] = {
        transition: 'opacity 300ms ease-in',
        opacity: 0,
    },
    _e['&.active'] = {
        img: { border: '4px solid #ffc220' },
        '.name': {
            opacity: 1,
            fontSize: 23,
            fontWeight: 600,
            whiteSpace: 'nowrap',
        },
        '.city': {
            opacity: 1,
            fontSize: 16,
            fontWeight: 500,
            whiteSpace: 'nowrap',
        },
    },
    _e));
var ImageLink = function (_a) {
    var img = _a.img, handleClick = _a.handleClick;
    return (React.createElement(ImageContainer, { role: "button", onClick: handleClick, container: true },
        React.createElement("img", { loading: "lazy", className: "people_img", src: img, alt: "people" })));
};
var RectangleImageCarousel = function (_a) {
    var items = _a.items, LinkComponent = _a.LinkComponent, brandEntity = _a.brandEntity, routePrefix = _a.routePrefix;
    var _b = useState(null), swiperIns = _b[0], setSwiperIns = _b[1];
    return (React.createElement(TextCarouselContainer, null,
        React.createElement(Wrapper, null,
            React.createElement(Swiper, { slidesPerView: 'auto', centeredSlides: true, spaceBetween: 30, onSwiper: function (s) { return setSwiperIns(s); }, modules: [Navigation], navigation: true, loop: true }, items &&
                __spreadArray([], items, true).map(function (item, idx) {
                    return (React.createElement(SwiperSlide, { key: idx, style: {} }, function (_a) {
                        var _b;
                        var isActive = _a.isActive, isNext = _a.isNext, isPrev = _a.isPrev;
                        if (isActive) {
                            return (React.createElement(LinkComponent, { to: checkAndAppendRoutePrefixToLink("".concat((brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.id) || ''), routePrefix, ((_b = item === null || item === void 0 ? void 0 : item.link) === null || _b === void 0 ? void 0 : _b.id) || '') },
                                React.createElement(ImageLink, { img: item.image, handleClick: function () { return void {}; } })));
                        }
                        return (React.createElement(ImageLink, { img: item.image, handleClick: function () {
                                if (isNext) {
                                    swiperIns === null || swiperIns === void 0 ? void 0 : swiperIns.slideNext();
                                }
                                else if (isPrev) {
                                    swiperIns === null || swiperIns === void 0 ? void 0 : swiperIns.slidePrev();
                                }
                            } }));
                    }));
                })))));
};

export { RectangleImageCarousel };
//# sourceMappingURL=index.js.map
